import { useMediaQuery, useTheme } from '@mui/material'

export const useMobileBreakpoints = (): boolean => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('lg'))
}
